






























































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';   
import _ from 'lodash';
import { TextTemplateService } from '@/service/TextTemplateService';
import CustomStore from 'devextreme/data/custom_store';
import { TextTemplateTypeEnum } from '@/models/TextTemplateTypeEnum';
import DataSource from 'devextreme/data/data_source';  
import {DxLookup} from 'devextreme-vue/lookup';
import {DxButton} from 'devextreme-vue/button';
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxFormItem,
  DxHeaderFilter,
  DxFilterRow,
  DxScrolling,
  DxLoadPanel,
  DxSelection
} from 'devextreme-vue/data-grid';
import {DxValidator, DxRequiredRule} from 'devextreme-vue/validator';
import { ClientReportOptionDto } from '@/models/client/ClientReportOptionDto';
import { ClientAgentService } from '@/service/ClientAgentService';
import DevExpress from 'devextreme';
import { ClientAgentInfoDto } from '@/models/client-agent/ClientAgentInfoDto';

@Component({
    components: { 
        DxLookup,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxFormItem,
        DxHeaderFilter,
        DxFilterRow,
        DxScrolling,
        DxLoadPanel,
        DxSelection
    }
})

export default class AuditorReport extends Vue {
    public $refs: Vue['$refs'] & {
        clientAgentSelection?: DxDataGrid;
    } = {};
    @Prop({ default: false })
    showEmailTemplate!: boolean;

    @Watch("showEmailTemplate")
    onValueChanged(newValue: boolean, oldValue: boolean) {
        if(!newValue) {
            this.auditorEmailDataSource.reload();
        }
    }

    @Prop({default : false}) 
    visible!: boolean;

    @Prop()
    clientReportOptionModel!: ClientReportOptionDto;

    @Prop()
    selectedClientAgentIds!: number[] | null;    

    get clientAgentDataGrid(): DevExpress.ui.dxDataGrid {
        return ((this.$refs.clientAgentSelection as any).instance as DevExpress.ui.dxDataGrid);
    }    

    get selectedKeys() {
        return this.selectedClientAgentIds;
    }
    get clientReportModel() {
        return this.clientReportOptionModel;
    }
    set clientReportModel(val: ClientReportOptionDto) {
        this.clientReportOptionModel = val;
    }

    get visibility() : boolean {
        return this.visible;
    }

    get agentToCustomStoreOptions() {
      return new CustomStore({      
              key: 'ClientAgentId',
              load: (options): Promise<any> => {
                if(this.clientReportModel.ClientId) {
                  return this.clientAgentService
                      .getClientAgentForReport(this.clientReportModel.ClientId,options)
                      .then((result: any) => {
                        this.getSelectedKeys(result.Data.data);

                        return result.Data;                                
                      })
                      .catch(err => {
                          return [];
                      });
                }
                else {
                  return Promise.resolve([]);
                }
              }           
          });
    }

    getSelectedKeys(data:any) {        
        if(this.selectedKeys == null) {
            let selectedKeys = data.filter((item: any) => item.ReceivesReport)
                                                .map((item: any) => item.ClientAgentId);

            this.$emit("update:selectedClientAgentIds", selectedKeys);
        }
    }
    

    clientAgentService: ClientAgentService;
    textTemplateService: TextTemplateService;
    auditorEmailStore: CustomStore = new CustomStore({
        loadMode: 'raw',
          load: (options): Promise<any> => {
          return this.textTemplateService.getTextTemplate(TextTemplateTypeEnum.AuditorReport)
              .then((results : any) => {
                  return results;
              }
              
              )
              .catch(err=> []);
          }
    });
    auditorEmailDataSource: DataSource = new DataSource({
        store: this.auditorEmailStore,
        searchExpr: "Name"
    })

    constructor() {
        super();
        this.textTemplateService = new TextTemplateService();
        this.clientAgentService = new ClientAgentService();
    }
    onOpenTemplateEditor(e:any) {
        this.$emit("update:showEmailTemplate", true);
    }

    openEdit(e:any) {        
        this.$emit("showEdit", e);
    }

    selectedIdsTemp: number[] | undefined;
    onSelectionChanged(e:any) {        
        let selectedRowKeys =  e.component.getSelectedRowKeys();
        
        this.$emit("update:selectedClientAgentIds", selectedRowKeys);
    }        

    private onContentReady(e:any): void {        
        if(!e.component.__firstLoad) {                    
            e.component.option("selectedRowKeys", this.selectedKeys);

            e.component.__firstLoad = true;
        }            
    }

    mounted() {
        this.$root.$on("refresh-client-agent-selection", this.handleEventBus);
    }

    beforeDestroy() {
        this.$root.$off("refresh-client-agent-selection", this.handleEventBus);
    }        

    private handleEventBus(data: ClientAgentInfoDto): void {                  
        // manually update the row            
        const focusedRowKey = this.clientAgentDataGrid.option('focusedRowKey');
        
        const rows = this.clientAgentDataGrid.getVisibleRows();
        const rowIndex = this.clientAgentDataGrid.getRowIndexByKey(focusedRowKey);    
        
        let row = rows[rowIndex];           
        
        row.data.AgentCCEmail = data.AgentCCEmail;
        row.data.AgentEmail = data.AgentEmail;
        row.data.PrimaryAlias = data.PrimaryAlias; 
        row.data.Jurisdictions = data.Jurisdictions;
        row.data.JurisdictionFree = data.JurisdictionFree;
        row.data.VendorNumber = data.VendorNumber;
        row.data.UnsetCountries = data.UnsetCountries;

        let rowIndexes = [];
        rowIndexes.push(rowIndex);

        this.clientAgentDataGrid.repaintRows(rowIndexes);      
    }    

    private sortBatchFilter(data: any): void {        
        data.dataSource.postProcess = (results: any) => {  
            return _.orderBy(results,['value'],['desc']);
        }
    }  
}
